import jQuery from './assets/js/jquery.js'
window.jQuery = window.$ = jQuery